export default __webpack_public_path__ + "static/media/direct-deposit.f47f9d61.svg";